import { IAgency } from "../resources-vue/vue-interfaces/i-agency";
import config from "./config";

export const getHospiceRedirectionUrl = (agencyId: string) => {
    const clusterDetails = JSON.parse(sessionStorage.getItem("hospice-cluster-details"));
    let baseUrl = "";
    clusterDetails?.forEach((cluster: IAgency) => {
        if (cluster.AgencyId === agencyId) {
            let redirectUrl: string | string[] = cluster.redirectUrl;
            redirectUrl = redirectUrl.split("?")[0];
            baseUrl = `${redirectUrl}`;
        }
    });

    return baseUrl;
};
